<!-- <color-twitter [color]="color" [colors]="colors" triangle="hide" (onChangeComplete)="handleChangeComplete($event)" width="238"></color-twitter> -->
<nb-accordion multi kwExpandFirstItem>
    <nb-accordion-item *ngFor="let field of fields;let i = index" [expanded]="i == '0'">
        <nb-accordion-item-header>{{field?.title}}</nb-accordion-item-header>
        <nb-accordion-item-body>
            <kve-field-editor [field]="field"></kve-field-editor>
        </nb-accordion-item-body>
    </nb-accordion-item>
</nb-accordion>
